<template>
  <div class="topnav pa3 pt3">
    <slot></slot>
  </div>
</template>

<script>

export default {
  name: 'topnav',
  data() {
    return {
    };
  },
  components : {
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
</style>



// WEBPACK FOOTER //
// TopNav.vue?4e7099e5